/*
 * Author: Andrew Seeley
 * Date: 20/11/2017
 * Copyright © 2018 Leap in!. All rights reserved.
 *
 * Constants for the profile reducer & actions.
 */

import {
  supportCapital,
  supportCore,
  supportCapacity,
  PRManageMembersImage,
  PRManageMembersSelectedImage,
  PRProfileImage,
  PRProfileSelectedImage,
  PRPlanMeetingImage,
  PRPlanMeetingSelectedImage,
  editIcon,
  MessagesRed3x,
  BudgetsIconWhite,
  BudgetsIconCharcoal,
  ApprovalsRed3x,
  ClaimInvoiceRed3x,
  BudgetsIconRed,
  MyDocumentsRed4x,
  DocumentsRed3x,
  GreyClockIcon3x,
} from '../assets/images/vector-icons';
import * as images from '../assets/images/vector-icons';

import * as brand from '../Constants/BrandConstants';
import {BrandColors} from '../../src/Styles/Colours';
import * as defaultImages from '../assets/images';
import {BrandIcons} from '../Styles/BrandIcons';

import CommonStyles from '../Styles/CommonStyles';
import BrandStyles from '../Styles/BrandStyles';
import {PM_SIGN_UP_URL, PM_DEMO_EMAIL, PR_DEMO_EMAIL} from '../environments';
import {
  DEMO_OPTIONS_CHOOSE_GUIDE_ME_TYPE_MG_BUDGET,
  DEMO_OPTIONS_CHOOSE_GUIDE_ME_TYPE_NDIS_PLANING,
  DEMO_OPTIONS_COLORS_WELCOME_EXPLORE,
  DEMO_OPTIONS_COLORS_WELCOME_LOGIN,
  DEMO_OPTIONS_COLORS_WELCOME_SCREEN_SIGN_UP_PROFILE,
  DEMO_OPTIONS_COLORS_WELCOME_SHOW_ME_AROUND,
  DEMO_OPTIONS_COLORS_WELCOME_SIGN_UP,
} from '../Styles/OnboardingStyles';

// Generic app info
export const SET_FORM_NEXT_REF = 'form_next_ref';
export const HTTP = 'http:';
export const HTTPS = 'https:';
export const WEBSITE_HOME = 'www.leapin.com.au';
export const PLAY_STORE = `${HTTPS}//itunes.apple.com/au/app/leap-in-ndis-planning/id1399430949?mt=8`;
export const APP_STORE = `${HTTPS}//play.google.com/store/apps/details?id=com.planready`;
export const WEBSITE_TIPS_TRICKS = `${HTTP}//www.leapin.com.au`;
export const BUILD_ENVIROMENT_DISPLAY_ARRAY = ['dev', 'qa', 'uat'];
export const APP_TYPE_STAFF = 'STAFF';

// My Profile Crew
export const DISPLAY_MAX_CREWS_MYPROFILE = 12;
export const DISPLAY_MAX_CREWS_MYPROFILE_TABLET = 9;
export const DISPLAY_MAX_CREWS_MYPROFILE_PHONE = 3;

export const DISPLAY_MAX_GOALS_MYPROFILE = 12;
export const DISPLAY_MAX_GOALS_MYPROFILE_TABLET = 9;
export const DISPLAY_MAX_GOALS_MYPROFILE_PHONE = 3;

export const DISPLAY_MAX_SUPPORTS_MYPROFILE = 12;
export const DISPLAY_MAX_SUPPORTS_MYPROFILE_TABLET = 9;
export const DISPLAY_MAX_SUPPORTS_MYPROFILE_PHONE = 3;

export const CREW_DISPLAY_MAX_VALUE = 3;

export const PHOTOTILE_EXTRAWIDTH_FORCAPTION = 150;

export const isWeb = typeof document != 'undefined';

// Plans
export const PLANS_TYPE = {
  active: {
    desc: 'Current',
    bubbleBgColorStyle: {
      backgroundColor: BrandColors.RESPONSIVE_DESIGN_COLORS.RED,
    },
    bubbleTextColorStyle: {color: BrandColors.WHITE},
  },
  inactive: {
    desc: 'Inactive',
    bubbleBgColorStyle: {
      backgroundColor: BrandColors.RESPONSIVE_DESIGN_COLORS.MID_GREY,
    },
    bubbleTextColorStyle: {color: BrandColors.WHITE},
  },
  claimable: {
    desc: 'Claimable',
    bubbleBgColorStyle: {
      backgroundColor: BrandColors.RESPONSIVE_DESIGN_COLORS.YELLOW,
    },
    bubbleTextColorStyle: {
      color: BrandColors.RESPONSIVE_DESIGN_COLORS.CHARCOAL,
    },
  },
};
export const PLAN_STATUS = {
  ACTIVE: 'active',
  IN_ACTIVE: 'inactive',
  CLAIMABLE: 'claimable',
};

// My Profile & Support sub items
export const DISPLAY_MAX_SUB_ITEMS_TAB_LANDSCAPE = 3;
export const DISPLAY_MAX_SUB_ITEMS_TAB_PORTRAIT = 2;
export const DISPLAY_MAX_SUB_ITEMS_PHONE_PORTRAIT = 1;

export const DISPLAY_MAX_SUB_ITEMS_TAB_PORTRAIT_GRIDVIEW = 2;
export const DISPLAY_MAX_SUB_ITEMS_PHONE_PORTRAIT_GRIDVIEW = 1;

// Delays
export const BANNER_TIMER = 7000;
export const API_TIMEOUT_CHECK = 10000;
export const API_REFERENCE_TIMEOUT_CHECK = 60000 * 30; // 60000ms * 30  = 30 mins
export const LAMBDA_CONNECT_TIMEOUT = 1000 * 30; // 30 seconds time out if it cannot connect
export const LAMBDA_TIMEOUT = 1000 * 60; // 15 seconds inactivity timeout.
export const USER_INACTIVITY_TIMEOUT = 1000 * 60 * 60 * 48;
export const USER_INACTIVITY_CHECK_INTERVAL = 1000;

export const CREATE_PROFILE = 'create_profile';
export const UPDATE_PROFILE = 'update_profile';
export const UPDATE_PROFILE_PLAN_TYPE = 'update_profile_plan_type';
export const UPDATE_PROFILE_SIGNUP_TYPE = 'update_profile_signup_type';
export const UPDATE_PROFILE_ISMEMBER = 'update_profile_ismember';
export const UPDATE_PROFILE_ISCREW = 'update_profile_iscrew';
export const UPDATE_TYPE_CONFIRMED = 'update_type_confirmed';

export const FIRST_NAME = 'firstname';
export const LAST_NAME = 'lastname';
export const EMAIL = 'email';
export const PASSWORD = 'password';
export const LOGIN_SUCCESS = 'login_success';
export const LOGIN_FAILURE = 'login_failure';
export const LOGOUT = 'logout';
export const SYSTEM_UNDER_MAINTAINED = 'system_under_maintained';

export const GET_USER = 'get_user';
export const UPDATE_USER = 'update_user';
export const UPDATE_USER_PLAN_TYPE = 'update_profile_plan_type';
export const UPDATE_USER_SIGNUP_TYPE = 'update_profile_signup_type';
export const UPDATE_USER_ISMEMBER = 'update_profile_ismember';
export const UPDATE_USER_ISCREW = 'update_profile_iscrew';
export const UPDATE_USER_NUMBEROFMEMBERS = 'update_user_numberofmembers';
export const UPDATE_USER_GUIDE_STATUS = 'update_user_guide_status';
export const SET_FIRST_TIME_SIGN_UP = 'set_first_time_sign_up';

export const GET_LOADED_MEMBER_ID = 'get_loaded_member_id';
export const UPDATE_LOADED_MEMBER_ID = 'update_loaded_member_id';
export const NEWLY_ADDED_MEMBER_ID = 'newly_added_member_id';

export const DETERMINE_SHOW_CONFIRM_NAVIGATION =
  'determine_show_confirm_navigation';
export const SHOW_CONFIRM_NAVIGATION = 'show_confirm_navigation';
export const HIDE_CONFIRM_NAVIGATION = 'hide_confirm_navigation';
export const CONTINUE_NAVIGATION = 'continue_navigation';
export const SHOW_LOGOUT_CONFIRMATION = 'show_logout_confirmation';
export const HIDE_LOGOUT_CONFIRMATION = 'hide_logout_confirmation';
export const LOGOUT_USER = 'logout_user';
export const INVOICE_DECLINE = 'invoice_decline';

export const SET_NAVIGATION_PARAM = 'set_navigation_param';

export const GET_MEMBER = 'get_member';
export const UPDATE_MEMBER = 'update_member';
export const GET_MOST_RECENT_MEMBERS = 'get_most_recent_members';
export const SET_RELATIONSHIP_FOR_MEMBER = 'set_relationship_for_member';
export const UPDATE_MEMBER_PHOTO_CAPTION = 'update_member_photocaption';
export const GET_BUDGETS = 'get_budgets';
export const ADD_PLANS = 'ADD_PLANS';
export const ADD_BUDGET_UNDER_MAINTENANCE_STATUS =
  'ADD_BUDGET_UNDER_MAINTENANCE_STATUS';
export const GET_BUDGET_CATEGORIES = 'get_budget_categories';
export const SET_PM_EXPIRED = 'set_pm_expired';
export const ADD_TRANSACTIONS = 'add_transactions';
export const GET_LIVING_ARRANGEMENT = 'get_living_arrangement';
export const GET_LIVING_ARRANGEMENT_REFERENCE =
  'get_living_arrangement_reference';
export const UPDATE_LIVING_ARRANGEMENT_HOME = 'update_living_arrangement_home';
export const UPDATE_LIVING_ARRANGEMENT_MODIFICATION =
  'update_living_arrangement_modification';
export const WHO_I_LIVE_WITH = {
  SET_DATA: 'set_who_i_live_with_data',
  RESET_DATA: 'reset_who_i_live_with_data',
  UPDATE_ON_SAVE: 'update_who_i_live_with_on_save',
};
export const SET_WHO_I_LIVE_WITH_DATA = 'set_who_i_live_with_data';
export const GET_FAVOURITE_THINGS = 'get_favourite_things';
export const RESET_TEMP_SUPPORT = 'reset_temp_support';
export const ADD_TEMP_SUPPORT_ITEMS = 'add_temp_support_items';
export const ADD_TEMP_SUPPORT_CATEGORIES = 'add_temp_support_categories';
export const ADD_TEMP_SUPPORT_CREW = 'add_temp_support_crew';
export const ADD_SUPPORT_STEP = 'add_support_step';
export const ADD_SUPPORT_PHOTO_CAPTION = 'add_support_photo_caption';
export const ADD_GOAL_PHOTO_CAPTION = 'add_goal_photo_caption';
export const GET_SUPPORTS = 'get_supports';
export const ADD_OWN_SUPPORT_ITEMS_ACTION = 'add_own_supports';
export const REMOVE_OWN_SUPPORT_ITEMS_ACTION = 'remove_own_support';
export const DELETE_SUPPORT = 'delete_support';
export const GET_SUPPORT_CATEGORIES = 'get_support_categories';
export const GET_SUPPORT_ITEM_GROUPS = 'get_support_item_groups';
export const GET_SUPPORT_ITEM_GROUP = 'get_support_item_group';
export const GET_SUPPORT_ITEMS = 'get_support_items';
export const CREATE_SUPPORT = 'create_support';
export const UPDATE_FAVOURITE_LIKE_TO_DO = 'update_favourite_like_to_do';
export const UPDATE_FAVOURITE_WOULD_LIKE_TO = 'update_favourite_would_like_to';
export const GET_HEALTH_WELLBEING = 'get_health_wellbeing';
export const UPDATE_HEALTH_WELLBEING_GOING_WELL =
  'update_health_wellbeing_going_well';
export const UPDATE_HEALTH_WELLBEING_CONCERNS =
  'update_health_wellbeing_concerns';
export const GET_CREWS = 'get_crews';
export const GET_CREW_CAT = 'get_crew_category';
export const CREWS = {
  SET_CREW_ITEM: 'set_crew_item',
  ADD_EDIT_CREW_LIST: 'add_edit_crew_list',
  DELETE_CREW_FROM_LIST: 'delete_crew_from_list',
  CREW_UPDATED: 'updated_crew_date',
};
export const PLAN_MANAGEMENT = {
  SET_MANAGEMENT: 'set_management',
  UPDATE_MANAGEMENT: 'update_management',
};
export const RESET = 'reset';
export const RESET_STORE = 'reset_store';
export const GET_FEATURE_FLAGS = 'get_feature_flags';
export const GET_DOCUMENT_LIST = 'get_document_list';
export const GET_AVATAR_LIST = 'get_avatar_list';
export const GET_AVATAR_IMAGE64 = 'get_avatar_image64';
export const GET_AVATAR_STATUS = 'get_avatar_status';
export const DOCUMENT_FILE_TYPE = 'document';
export const GET_SERVICE_AGREEMENTS_LIST = 'get_service_agreements_list';
export const GET_CREW_CREATE_MEMBER = 'get_crew_create_member';
export const GET_PAY_INVOICE_STEP = 'get_pay_invoice_step';
export const GET_PAY_INVOICE_VIEW = 'get_pay_invoice_view';
export const GET_MEMBER_BILLERS = 'get_momber_bnillers';
export const ADD_NEW_PROVIDER = 'add_new_provider';
export const ADD_INVOICE_ACTION = 'add_invoive_action';
export const ADD_SUPPORT_ITEMS_ACTION = 'add_support_items_action';
export const ADD_SUPPORT_ITEMS_COLLECTIONS_ACTION =
  'add_support_items_collection_action';
export const SET_PAYMENT_SUBMIT_RESULT = 'add_support_items_collection_action';
export const SET_INVOICE_DOC = 'set_invoice_doc';
export const REMOVE_SUPPORT_ITEMS_ACTION = 'remove_support_item_action';
export const SET_DRAFT_INVOICES_COUNT = 'set_draft_invoices_count';
export const SET_LIST_REFERRALS = 'set_list_referrals';
export const SET_PROVIDER_LIST = 'set_provider_list';
export const SET_SELECTED_PROVIDER = 'set_selected_provider';
export const SET_ENQUIRY_DESCRIPTION = 'set_enquiry_description';
export const NAVIGATE_BACK_TO_PREVIOUS_SCREEN =
  'navigate_back_to_previous_screen';
export const SET_CATEGORY_REFERRAL = 'set_category_referral';
export const SKIP_UNWANTED_STACK_SCREEN = 'set_unwanted_stack_screen';

// Provider Enquiry info checks
export const SET_MEMBER_ADDRESS_CHECKED = 'set_member_address_checked';
export const SET_CREW_MOBILE_NUMBER_CHECKED = 'set_crew_mobile_number_checked';
export const SET_MEMBER_PHONE_NUMBER_CHECKED =
  'set_member_phone_number_checked';
export const SET_MEMBER_MOBILE_PHONE_CHECKED =
  'set_member_mobile_phone_checked';
export const SET_MEMBER_DISABILITIES_CHECKED =
  'set_member_disabilities_checked';
export const SET_CREW_RELATIONSHIP_CHECKED = 'set_crew_relationship_checked';
export const SET_CATEGORY_GROUP = 'set_category_group';
export const SET_CATEGORY_INDEX = 'set_category_index';

export const GOALS = {
  GET_GOALS: 'get_goals',
  EDIT_GOAL: 'edit_goal',
  ADD_NEW_GOAL: 'add_new_goal',
  SET_STEP_LIST: 'set_step_list',
  ADD_STEP: 'add_step',
  SET_GOAL_NAME: 'set_goal_name',
  UPDATE_GOAL_STEP: 'update_goal_step',
  UPDATE_GOAL_NAME: 'update_goal_name',
  UPDATE_GOAL_IN_LIST: 'update_goal_in_list',
  ADD_GOAL_TO_LIST: 'add_goal_to_list',
  SET_GOAL_ID: 'set_goal_id',
  SET_GOAL_IMAGE: 'set_goal_image',
  SET_GOAL_IMAGE_LIST_LOCAL: 'set_goal_image_list_local',
  EDIT_EXISTING_GOAL: 'edit_existing_goal',
  GET_GOAL_TEMPLATES: 'get_goal_templates',
  SET_GOAL_TEMPLATE: 'set_goal_template',
  SET_GOAL_STEPS_FOR_TEMPLATE: 'set_goal_steps_for_template',
  GET_FILTERS_REFERENCE: 'get_filters_reference',
  SET_FILTERS_SELECTED: 'set_filters_selected',
  DELETE_GOAL_FOR_ID: 'delete_goal_for_id',
  EDIT_GOAL_STEP: 'edit_goal_step',
  BACKUP_GOAL_READONLY: 'backup_goal_readonly',
  CANCEL_GOAL_EDITS: 'cancel_goal_edits',
  FILTER: {
    CATEGORY: 'category',
    LIFESTAGE: 'lifestage',
  },
  GET_GOAL_PROGRESS: 'get_goal_progress',
};

export const SUPPORTS = {
  SET_SUPPORT_IMAGE: 'set_support_image',
  SET_SUPPORT_IMAGE_LIST_LOCAL: 'set_support_image_list_local',
};

export const FAVOURITE_THINGS = {
  TODAY: 'today',
  FUTURE: 'future',
  LIKE_TO_DO: 'likeToDo',
  WOULD_LIKE_TO_DO: 'wouldLikeToDo',
};

export const HEALTH_WELLBEING = {
  ONGOING_HEALTH: 'ongoingHealth',
  HEALTH_CONCERNS: 'healthConcerns',
};

// Messages

export const MESSAGES_ALREADY_APPROVED = 'Already approved.';

export const MESSAGES_SA_APPROVED =
  'You had a service agreement to approve but it’s been done already';

export const CHANGE_CONNECTION_STATUS = 'change_connection_status';

export const LOGIN_TYPE_FACEBOOK = 'login_type_facebook';
export const LOGIN_TYPE_GOOGLE = 'login_type_google';
export const LOGIN_TYPE_EMAIL = 'login_type_email';
export const LOGIN_LAST_TYPE = 'login_last_type';
export const LOGIN_NO_TYPE = 'no_last_login';
export const LAST_ACTIVE_TIME = 'last_active_time';

// Cognito responses to indicate whether a challenge has occurred
export const COGNITO_TYPE_CHALLENGE = 'cognito_pwd_challenge';
export const COGNITO_TYPE_LOGIN = 'cognito_login_success';
export const COGNITO_TEMP_PASSWORD_EXPIRED =
  'Temporary password has expired and must be reset by an administrator.';

// Used if you are new or existing ndis plan
export const PLAN_TYPE = 'plan_type'; // Used with the storage helper to store the plan type
// The different plan types
export const PLAN_TYPE_NEW = 'plan_type_new';
export const PLAN_TYPE_EXISTING = 'plan_type_existing';

// This is used to store the sign up type - if it is a participant or crew
export const SIGNUP_TYPE = 'signup_type';
// The different sign up types
export const SIGNUP_TYPE_CREW = 'signup_type_crew';
export const SIGNUP_TYPE_PARTICIPANT = 'signup_type_participant';

// Choose from drives
export const FROM_DRIVES_KEY = 'drives';
export const FROM_DRIVES = 'Choose from drives....';

// Screen type strings
export const SCREEN_TYPE_MAIN = 'main';
export const SCREEN_TYPE_MAIN_ALTERNATIVE = 'main_alternative';
export const SCREEN_TYPE_EDIT = 'edit';

// Document Add form
export const DOCUMENTADDFORM = 'DocumentAddForm';

// Keys for keychain
export const COGNITO_KEY = 'cognito';

// Screen name Strings -- This is used for setting the selected icon in the screen headers
export const SCREEN_NOTIFICATIONS = 'screen_notifications';
export const SCREEN_DOCUMENTS = 'screen_documents';
export const SCREEN_SETTINGS = 'screen_settings';
export const SCREEN_UPLOAD_PLAN = 'upload_plan';
export const SCREEN_HELP = 'screen_help';
export const SCREEN_PLAN_SUMMARY = 'screen_plan_summary';
export const SCREEN_MANAGE_MEMBERS = 'screen_manage_members';
export const SCREEN_TERMS_CONDITIONS_FULL_PM =
  'screen_terms_conditions_full_pm';
export const SCREEN_TERMS_CONDITIONS_PM = 'screen_terms_conditions_pm';
export const SCREEN_CHANGE_PASSWORD = 'screen_change_password';
export const SCREEN_PROFILE_PICTURE = 'screen_profile_picture';
// The screen mode for the Login/Signup screen as it can be one of three states which will determine
// The screen contents & behaviour
export const LOGINSIGNUP_MODE_SIGNUP = 'loginsignup_mode_signup';
export const LOGINSIGNUP_MODE_LOGIN = 'loginsignup_mode_login';
export const PREVIOUSLY_SIGNIN = 'isLoggedIn';

export const LOGINSIGNUP_MODE_REQUESTACCESS = 'loginsignup_mode_requestaccess';
export const LOGINSIGNUP_CREW_CREATE_MEMBER =
  'loginsignup_mode_crewcreatemember';
export const ADD_MEMBER = 'ADD_MEMBER';
// Profile access constants
export const ACCESS_NONE = 'none';
export const ACCESS_READ_ONLY = 'read';
export const ACCESS_FULL = 'full';
export const ACCESS_DECISION_MAKER_YES = true;
export const ACCESS_DECISION_MAKER_NO = false;

// Profile notification
export const NOTIFICATION_IN_APP = 'in_app';
export const NOTIFICATION_IN_APP_EMAIL = 'in_app_email';
export const NO_NOTIFICATION = 'No messages';
export const PULL_TO_REFRESH = 'Pull down to refresh';

// Who i live with

export const WHO_I_LIVEWITH_NO_CREW_MESSAGE =
  'To add the crew you live with,click the add button above';
export const WHO_I_LIVEWITH_SELECT_MESSAGE =
  'Tick or untick the people who you live with.';

// Error & Informational messages
export const TANDC_NOT_ACCEPTED = 'Terms and conditions is required';
export const PASSWORD_IS_REQUIRED = 'Password is Required';
export const PASSWORD_INVALID = 'Password is Invalid';
export const PASSWORD_INVALID_LENGTH =
  'Password must be 8 or more characters long';
export const PASSWORD_CONTAINS_SPACES = 'Password must not contain spaces';
export const EMAIL_INVALID_FORMAT = 'Enter a valid email';
export const LASTNAME_NOT_ENTERED = 'Last name is required';
export const FIRSTNAME_NOT_ENTERED = 'First name is required';
export const GOAL_NAME_NOT_ENTERED = 'Goal name is mandatory';
export const GOAL_STEP_NAME_NOT_ENTERED = 'Step name is mandatory';
export const GOAL_STEP_DESCRIPTION_NOT_ENTERED =
  'Step description is mandatory';
export const GOAL_NO_STEPS_ENTERED = 'You must have at least 1 goal step';
export const TOKEN_LENGTH = 'Token must be 6 digits long';
export const TOKEN_TYPE = 'Token must only contain digits';
export const INVALID_PHONE_NAN = 'Home phone must only contain digits ';
export const INVALID_MOBILE_PHONE = 'Mobile phone must be less than 25 digits';
export const INVALID_POSTCODE_NAN = 'Postcode must only be digits ';
export const INVALID_POSTCODE_LENGTH = 'Postcode must be 4 digits';
export const DOB_INCORECT = 'Enter a valid date of birth';
export const DOCUMENT_NAME_NOT_ENTERED = 'Document name is required';
export const INVALID_NDIS_NUMBER = 'NDIS number must only contain digits';
export const VALID_DOCUMENT_TYPES = ['.docx']
export const POST_CODE_ACCESSIBILITY = 'Postcode';
export const DraftInvoice = 'DraftInvoice'
export const ORGANISATION_NAME_NOT_ENTERED = 'Organisation name is required';
export const ABN_NOT_ENTERED = 'ABN is Required';
export const EMAIL_NOT_ENTERED = 'Email is Required';
export const EMAIL_REQUIRED_TO_GIVE_ACCESS =
  'Email is required to give this person access';
export const BSB_NOT_ENTERED = 'BSB is Required';
export const ACCNUMBER_NOT_ENTERED = 'Bank Account Number is Required';
export const ORGANISATION_NAME_INVALID_FORMAT =
  'Enter a valid organisation name';
export const ABN_INVALID_FORMAT = 'Valid ABN should be 9 or 11 digits';
export const BSB_INVALID_FORMAT = 'Valid BSB should be 6 digits';
export const ACCNUMBER_INVALID_FORMAT =
  'Valid bank account number should be 9 digits or less';
export const ORGANISATION_NAME_EXISTS_ALERT =
  "You've already added this provider, please choose them from the list.";
export const EXISTING_VERIFIED_PROVIDER = [
  "We have this provider's ABN registered as ",
  ". It's ok for you to call them ",
  ' for your records, but can you confirm that this is actually ',
  '. Please confirm that this is the right provider?',
];
export const UPDATE_EXISTING_PROVIDER_CHANGED = {
  INITIAL_MESSAGE: `You've already set up a provider with ABN`,
  NAME: 'Name',
  EMAIL: 'Email',
  ACCOUNT_NUMBER: 'Account number',
  BSB: 'BSB',
  ENTER_DIFFERENT: ' You just entered a different',
  KEEP_SAME: 'but have kept the same',
  AS_PREVIOUS: 'as previously.',
  REPLACE_PROVIDER:
    ' Do you want to replace your old provider with this provider?',
};
export const INVALID_DATE = 'Invalid Date';
export const EXISTING_PARTNER_PROVIDER =
  'This provider is a Leap in! Partner. Partners lodge claims directly to Leap in!';
// Invoice Details Validations
export const INVOICENUMBER_NOT_ENTERED = 'Invoice Number is Required';
export const INVOICEDATE_NOT_ENTERED = 'Invoice Date is Required';
export const INVOICENUMBER_INVALID_FORMAT = 'Enter a valid Invoice Number';
export const INVOICEDATE_INVALID_FORMAT = 'Enter a valid Invoice date';
export const INVOICEUPLOAD_NOT_ENTERED = 'Please Upload invoice to proceed';
export const INVOICE_NO_PROVIDER_SELECTED =
  'Please select/add provider to proceed';
export const INVOIVE_SUPPORT_ITEM_EMPTY =
  'There are no support items to submit the invoice';

// Support Items Validations
export const SUPPORTITEM_NOT_ENTERED = 'Support Item is Required';
export const RATE_NOT_ENTERED = 'Rate is Required';
export const TIME_OR_UNIT_NOT_ENTERED =
  'Time in hours & mins OR unit is required';
export const ITEMTOTAL_NOT_ENTERED = 'Item Total is Required';
export const STARTDATE_NOT_ENTERED = 'Start Date is Required';
export const ENDDATE_NOT_ENTERED = 'End Date is Required';
export const RATE_INVALID_FORMAT = 'Enter a valid Rate';
export const HOURS_INVALID_FORMAT = 'Enter a valid Hours';
export const MINS_INVALID_FORMAT = 'Enter a valid Mins';
export const UNIT_INVALID_FORMAT = 'Enter a valid Unit';
export const ITEMTOTAL_INVALID_FORMAT = 'Enter a valid Item Total';
export const ENDDATE_INVALID_FORMAT =
  'End date should be a date after start date';

export const DOB_NOT_SELECTED = 'Date of Birth is required';
export const DOB_IS_MANDATORY_ACCESSIBLE_ERROR_TEXT = DOB_NOT_SELECTED;
export const PLAN_START_DATE_NOT_SELECTED = 'Plan start date is required';
export const PLAN_START_DATE_NOT_SELECTED_ACCESSIBLE_ERROR_TEXT =
  'Plan start date is required';
export const PLAN_NOT_UPLOADED = 'Plan is required';
export const PLAN_NOT_UPLOADED_ACCESSIBLE_ERROR_TEXT = 'Plan is required';
export const STATE_NOT_SELECTED = 'State is required';
export const NDIS_PARTICIPANT_ID_IS_MANDATORY_ERROR_TEXT =
  'NDIS  Participant ID is Required';
export const PHONE_NUMBER_IS_MANDATORY_ERROR_TEXT = 'Phone Number is Required';
export const PHONE_NUMBER_SHOULD_VALID_TEXT =
  'Add phone number without spaces or special characters';
export const NDIS_NUMBER_IS_MANDATORY_ACCESSIBLE_ERROR_TEXT =
  'N D I S   Number is Required';
export const PLAN_NUMBER_IS_MANDATORY_ERROR_TEXT = 'Plan Number is Required';
export const PLAN_NUMBER_IS_MANDATORY_ACCESSIBLE_ERROR_TEXT =
  PLAN_NUMBER_IS_MANDATORY_ERROR_TEXT;

// Error names from error objects
export const NOT_AUTHORIZED = 'NotAuthorizedException';
export const USER_NOT_FOUND = 'UserNotFoundException';
export const LIMIT_EXCEED = 'LimitExceededException';
export const NETWORK_FAILURE = 'NetworkingError';
export const USERNAME_EXISTS = 'UsernameExistsException';
export const TIMEOUT = 'Timeout';
export const VERSION_ERROR = '30003';
export const BAD_REQUEST_ERROR = '400';
export const MISSING_MANDATORY_CHECKBOX = 'MissingMandatoryCheckbox';
export const COGNITO_INVALID_SIGNATURE_ERROR = 403;
export const COGNITO_INVALID_SIGNATURE_ERROR_MESSAGE =
  'InvalidSignatureException';

// Modal modes
export const FORM_MODE_NEW = 'form_mode_new';
export const FORM_MODE_EDIT = 'form_mode_edit';
export const DEFAULT_ACCESS_CONTROL = 'none';
export const SAVE_MODAL_DATA = 'save modal data';
export const CLEAR_MODAL_DATA = 'clear modal data';

// Screen Modes
export const SCREEN_MODE_NEW = 'screen_mode_new';
export const SCREEN_MODE_EDIT = 'screen_mode_edit';

// In app Notifications
export const LOAD_NOTIFICATIONS = 'load_notifications';
export const CLICK_NOTIFICATIONS = 'click_notifications';
export const NOTIFICATIONS_PAGE_NUMBER = 'notifications_page_number';
export const NOTIFICATION_PAGE_SIZE = 10;

// AutoComplete
export const ADD_YOUR_OWN = 'Add your own';

export const NOTIFICATION_STATUS = {
  READ: 'read',
  UNREAD: 'unread',
};

// Action Buttons
export const ACTION_BUTTON = {
  EDIT: 'Edit',
  ADD: 'Add',
  VIEW: 'View',
  PRINT: 'Print',
  SHARE: 'Share',
  REVIEW: 'Review',
  DELETE: 'Delete',
  APPROVE: 'Approve',
  APPROVE_ALL: 'Approve All',
  DECLINE: 'Decline',
  SUBMIT_PRE_APPROVED: 'submit_pre_approved',
  DOWNLOAD: 'Download',
  UPDATE_NOTES: 'Update Notes',
};

// Types of banner message
export const BANNER_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
};

export const FIREBASE_VERSION = '_v2';

export const FIREBASE_ANALYTICS_EVENTS = {
  APP_INITIALIZED: `app_initialized${FIREBASE_VERSION}`,
  SIGNUP_LANDING: `signup_landing${FIREBASE_VERSION}`,
  LOGIN_LANDING: `login_landing${FIREBASE_VERSION}`,
  SIGNUP_CLICKED: `signup_clicked${FIREBASE_VERSION}`,
  LOGIN_CLICKED: `login_clicked${FIREBASE_VERSION}`,
  LOGIN_SUCCESS: `login_success${FIREBASE_VERSION}`,
  CREW_CREATE_PARTICIPANT: `crew_create_participant${FIREBASE_VERSION}`,
  CREW_CREATE_PARTICIPANT_SKIP: `crew_create_participant_skip${FIREBASE_VERSION}`,
  TABS_INITIALIZED: `tabs_initialized${FIREBASE_VERSION}`,
  SIGNUP_MEMBER_TYPE_SELECTION: `signup_member_type_selection${FIREBASE_VERSION}`,
  TYPE_CONFIRMED: `signup_type_confirmed${FIREBASE_VERSION}`,
  TYPE_PARTICIPANT_SELECTED: `signup_type_participant_selected${FIREBASE_VERSION}`,
  TYPE_CREW_SELECTED: `signup_type_crew_selected${FIREBASE_VERSION}`,
  SIGNUP_FACEBOOK: `signup_facebook${FIREBASE_VERSION}`,
  SIGNUP_GOOGLE: `signup_google${FIREBASE_VERSION}`,
  LOGIN_FACEBOOK: `login_facebook${FIREBASE_VERSION}`,
  LOGIN_GOOGLE: `login_google${FIREBASE_VERSION}`,
  SIGNUP_FOR_PLAN_MANAGEMENT_CLICKED: `signup_for_plan_management_clicked${FIREBASE_VERSION}`,
  PLAN_MANAGEMENT_FORM_FILLED: `plan_management_form_filled${FIREBASE_VERSION}`,
  READ_TERMS_AND_CONDITIONS_CLICKED: `read_terms_and_conditions_clicked${FIREBASE_VERSION}`,
  PLAN_MANAGEMENT_TERMS_AGREED: `plan_management_terms_agreed${FIREBASE_VERSION}`,
  SIGNUP_FOR_PLAN_MANAGEMENT_COMPLETED: `signup_for_plan_management_completed${FIREBASE_VERSION}`,
};

export const FIREBASE_ANALYTICS_USERS = {
  CREW: 'crew',
  PARTICIPANT: 'participant',
  EMPLOYEE: 'employee',
  FINANCIAL_STAFF: 'financialstaff',
};

// Supports
export const KEEP = 'Keep';
export const CHANGE = 'Change';
export const STOP = 'Stop';
export const DRIVER = 'Driver';
export const UNITOFMEASURE = 'UnitOfMeasure';
export const YEAR = 'Annually';
export const EACH = 'Each';
export const WEEK = 'Week';
export const DAY = 'Day';
export const HOUR = 'Hour';
export const RATIO = 'RATIO';
export const ASSESS = 'ASSESS';
export const COMPLEX_ASSESS = 'COMPLEX_ASSESS';
export const HOUSEHOLD = 'HOUSEHOLD';
export const USAGE = 'Usage';
export const TIMEOFDAY = 'TimeOfDay';
export const TIMESPERYEAR = 'TimesPerYear';
export const DAYSOFUSE = 'DaysOfUse';
export const FREQUENCY = 'Frequency';
export const COST = 'Cost';
export const HOURS_PER_VIST = 'Hours';
export const DAYSOFTHEWEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const DAYSOFWEEK_LABELS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];
export const TIMEOFUSEVALUE = ['Morning', 'Afternoon', 'Evening'];
export const COMPLEXASSESSDRIVERVALUES = ['Low', 'Standard', 'Complex'];
export const ASSESSDRIVERVALUES = ['Low', 'High'];
export const RATIOQUESTIONVALUES = ['Yes', 'No'];
export const WEEKLYUSAGEVALUES_ARRAY = [
  'Weekly',
  'Monthly',
  'From time to time',
];
export const HOURLYUSAGEVALUES_ARRAY = [
  'Weekly',
  'Monthly',
  'From time to time',
  'Just once',
  'Fortnightly',
];
export const HOURLYUSAGEVALUES = [
  {
    key: 0,
    description: 'Please select an option',
    type: 'Please select an option',
  },
  {key: 1, description: 'Weekly', type: 'Weekly'},
  {key: 2, description: 'Monthly', type: 'Monthly'},
  {key: 3, description: 'From time to time', type: 'From time to time'},
  {key: 4, description: 'Just once', type: 'Just once'},
  {key: 5, description: 'Fortnightly', type: 'Fortnightly'},
];
export const WEEKLYUSAGEVALUES = [
  {
    key: 0,
    description: 'Please select an option',
    type: 'Please select an option',
  },
  {key: 1, description: 'Weekly', type: 'Weekly'},
  {key: 2, description: 'Monthly', type: 'Monthly'},
  {key: 3, description: 'From time to time', type: 'From time to time'},
];

// Delete account request loaded from play store - More details in LCP 14
export const SETTINGS_URL_PATH_NAME = 'Settings';
export const IS_APP_LOADED_FROM_PLAY_STORE = 'isAppLoadedFromPlaySore';
export const LOGOUT_ICON = 'data:image/png;base64,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';

export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
export const SET_PAGE_NUMBER = 'SET_PAGE_NUMBER'
export const SET_PAYMENT_HISTORY_DATA = 'SET_PAYMENT_HISTORY_DATA'

export const FEATURE_FLAG_KEYS = {
  requestFlexCore: "requestFlexCore",
  requestMultiTranche: "requestMultiTranche"
}

export const CLAIMING_SYSTEMS_VALUES = {
  NDIS_LEGACY: 'NDIS Legacy',
  NDIS_PACE: 'NDIS PACE'
}

export const CORE_FLEXIBLE = "Core Flexible"